import React, { useEffect, useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import NavbarScroll from "./components/Navbar/NavbarScroll";
import WhatsAppIcon from "./components/WhatsAppIcon";
import Scroll from "./components/Scroll";
import Footer from "./components/Footer";

import LoginPage from "./login/LoginPage";
import Register from "./login/Usuario/Register";
import UpdatePasswordPage from "./login/Usuario/UpdatePasswordPage";
import UpdatePassworSystem from "./login/UpdatePasswordPage";

import HomePage from "./pages/HomePage";
import AboutUs from "./pages/AboutUsPage"
import CategoriesPage from "./pages/CategoriesPage";
import ServicesSPage from "./pages/ServicePage";
import ContactPage from "./pages/ContactPage";
import ProductDetail from "./components/Categories/ProductDetail";
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import OfferPage from "./pages/OfferPage";

import UserPanel from "./login/Usuario/UserPanel";
import AdminPanel from "./login/Administrador/AdminPanel";
import EnterprisePanel from "./login/Empresa/EnterprisePanel";
import NewInvoice from "./login/Empresa/NuevaFactura/NewInvoice";
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';

import AdminSection from "./login/Administrador/AdminSection";
import Section from "./login/Administrador/Section";
import AdminProduct from "./login/Administrador/AdminProduct";
import Product from "./login/Administrador/Product";
import AdminProforma from "./login/Administrador/AdminProforma";
import Proforma from "./login/Administrador/Proforma";
import AdminClient from "./login/Administrador/AdminClient";
import Client from "./login/Administrador/Client";
import AdminVariant from "./login/Administrador/AdminVariant";
import Variant from "./login/Administrador/Variant";
import AdminPromotion from "./login/Administrador/AdminPromotion";
import Promotion from "./login/Administrador/Promotion";
import AdminServices from "./login/Administrador/AdminServices";
import Services from "./login/Administrador/Services";
import AdminInvoice from "./login/Administrador/AdminInvoice";
import Invoice from "./login/Administrador/Invoice";
import RegisterPurchase from "./login/Administrador/RegisterPurchase";
import AdminAccounts from "./login/Administrador/AdminAccounts";
import AdminMotion from "./login/Administrador/AdminMotion";
import Motion from "./login/Administrador/Motion";
import MotionDetail from "./login/Administrador/MotionForm/MotionDetail";

import AdminBank from "./login/Administrador/AdminBank";
import Bank from "./login/Administrador/Bank";

import Payment from "./login/Administrador/Payment/Payment";


const AppLayout = ({ children }) => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const lastState = useRef(false);

  const isAuthOrAdmin =
    location.pathname === "/login" ||
    location.pathname.startsWith("/admin-panel");

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      if (!lastState.current && y > 160) {
        lastState.current = true;
        setScrolled(true);
      } else if (lastState.current && y < 80) {
        lastState.current = false;
        setScrolled(false);
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {!isAuthOrAdmin && (
        <>
          <div
            style={{
              opacity: scrolled ? 0 : 1,
              pointerEvents: scrolled ? "none" : "auto",
              transition: "opacity .28s ease",
            }}
          >
            <Navbar />
          </div>

          <div
            style={{
              position: "fixed",
              top: 8,
              left: "50%",
              transform: "translateX(-50%)",
              width: "90%",
              zIndex: 1200,
              opacity: scrolled ? 1 : 0,
              pointerEvents: scrolled ? "auto" : "none",
              transition: "opacity .28s ease",
            }}
          >
            <NavbarScroll />
          </div>
        </>
      )}

      <main style={{ flex: 1 }}>{children}</main>

      {!isAuthOrAdmin && <WhatsAppIcon />}
      {!isAuthOrAdmin && <Scroll />}
      {!isAuthOrAdmin && <Footer />}
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppLayout>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/actualizar-clave" element={<UpdatePasswordPage />} />
          <Route path="/system/update-password" element={<UpdatePassworSystem />} />

          <Route path="/" element={<HomePage />} />
          <Route path="/acerca-de-nosotros" element={<AboutUs />} />
          <Route path="/categorias" element={<CategoriesPage />} />
          <Route path="/servicios" element={<ServicesSPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/categorias/:sectionSlug/:categorySlug" element={<CategoriesPage />} />
          <Route
            path="/categorias/:sectionSlug/:categorySlug/:productSlug"
            element={<ProductDetail />}
          />
          <Route
            path="/categorias/:sectionSlug/:categorySlug/:productSlug/:variantSlug"
            element={<ProductDetail />}
          />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/ofertas" element={<OfferPage />} />
          <Route path="/buscar" element={<ProductPage />} />
          <Route path="/politicas-privacidad" element={<PrivacyPolicyPage />} />
          <Route path="/terminos-condiciones" element={<TermsAndConditionsPage />} />

          <Route path="/user-panel" element={<UserPanel />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/checkout/exito" element={<CheckoutSuccess />} />

          <Route path="/admin-panel/*" element={<AdminPanel />} />
          <Route path="/admin-panel/empresa" element={<EnterprisePanel />} />
          <Route path="/admin-panel/secciones" element={<AdminSection />} />
          <Route path="/admin-panel/secciones/nueva" element={<Section />} />
          <Route path="/admin-panel/inventario/productos" element={<AdminProduct />} />
          <Route path="/admin-panel/inventario/productos/nuevo" element={<Product />} />
          <Route path="/admin-panel/proformas" element={<AdminProforma />} />
          <Route path="/admin-panel/proformas/nueva" element={<Proforma />} />
          <Route path="/admin-panel/proformas/editar/:id" element={<Proforma />} />
          <Route path="/admin-panel/servicios" element={<AdminServices />} />
          <Route path="/admin-panel/servicios/nuevo" element={<Services />} />
          <Route path="/admin-panel/clientes" element={<AdminClient />} />
          <Route path="/admin-panel/clientes/nuevo" element={<Client />} />
          
          <Route path="/admin-panel/inventario/variantes" element={<AdminVariant />} />
          <Route path="/admin-panel/inventario/variantes/nueva" element={<Variant />} />
         
          <Route path="/admin-panel/promociones" element={<AdminPromotion />} />
          <Route path="/admin-panel/promociones/nueva" element={<Promotion />} />
          
          <Route path="/admin-panel/registro/documento" element={<NewInvoice />} />
          <Route path="/admin-panel/reporte/documento" element={<AdminInvoice />} />
          <Route path="/admin-panel/compras/registro" element={<RegisterPurchase />} />

          <Route path="/admin-panel/factura/:id" element={<Invoice />} />
          <Route path="/admin-panel/admin-cuentas" element={<AdminAccounts />} />

          <Route path="/admin-panel/inventario/movimientos" element={<AdminMotion />} />
          <Route path="/admin-panel/inventario/movimientos/nuevo" element={<Motion />} />
          <Route path="/admin-panel/inventario/movimientos/:id" element={<MotionDetail />} />

          <Route path="/admin-panel/bancos" element={<AdminBank />} />
          <Route path="/admin-panel/bancos/nuevo" element={<Bank />} />

          <Route path="/admin-panel/pagos/:id" element={<Payment />} />

        </Routes>
      </AppLayout>
    </Router>
  );
};

export default App;
